function i(e) {
  var f;
  return ((f = e || []) == null ? void 0 : f.length) > 0 && (e == null ? void 0 : e.every(
    (a) => a.stockProductId && a.count <= 0
  ));
}
export {
  i as default
};
